export enum FieldType {
	Group = 'group',
	Textbox = 'textbox',
	List = 'list',
	Checkbox = 'checkbox',
	Date = 'date',
	// eslint-disable-next-line id-blacklist
	Number = 'number',
	Staff = 'staff',
	ListOption = 'listOption',
}

export enum AllFilters {
	Clients = 'All Clients',
	Individuals = 'All Individuals',
	Businesses = 'All Businesses',
}
